import {AbstractEvent} from "@/modules/base/events";
import {Achievement} from "@/modules/archiements/entity";

export default class BeforeAchievementAchievedEvent extends AbstractEvent {
  constructor(
    public achievement: Achievement,
  ) {
    super();
  }
}